import React from "react";
import styles from "../statics/styles/file-upload-viewer-scss";
const OtherIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "42", viewBox: "0 0 40 42", ...props }, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { className: styles.file_upload_icon_frame, strokeLinejoin: "bevel" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M35.5 41.5h-32V.5h19.45L35.5 13.31z" }), /* @__PURE__ */ React.createElement("path", { d: "m22.59 13.36 12.91-.05-.64-.63L23.59 1.14 22.95.5z" })), /* @__PURE__ */ React.createElement(
  "path",
  {
    className: styles.file_upload_icon_background,
    d: "M14.463 23.09h10v1h-10zm0-4h10v1h-10zm5 12 5-4h-10z"
  }
)));
export {
  OtherIcon
};
//# sourceMappingURL=other-icon.js.map
